module.exports = __webpack_public_path__ + "img/astral_9.f2713c30.svg";